import { render, staticRenderFns } from "./addInsure.vue?vue&type=template&id=7043c6c7&scoped=true"
import script from "./addInsure.vue?vue&type=script&lang=js"
export * from "./addInsure.vue?vue&type=script&lang=js"
import style0 from "./addInsure.vue?vue&type=style&index=0&id=7043c6c7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7043c6c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7043c6c7')) {
      api.createRecord('7043c6c7', component.options)
    } else {
      api.reload('7043c6c7', component.options)
    }
    module.hot.accept("./addInsure.vue?vue&type=template&id=7043c6c7&scoped=true", function () {
      api.rerender('7043c6c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insure/customInsureManage/addInsure.vue"
export default component.exports